const SettingsTabs = () =>
  import("@/features/dep/settings/home/presentation/views/SettingsTabs.vue");

const DepGeneralConfiguration = () =>
  import("@/components/configuration/general/DepGeneralConfigurationSection");
const DepKnChatConfiguration = () =>
  import("@/components/configuration/kn-chat/DepKnChatConfigurationSection");
const DepKnExplorerConfiguration = () =>
  import(
    "@/components/configuration/kn-explorer/DepKnExplorerConfigurationSection"
  );
const DepMaterialsConfiguration = () =>
  import("@/components/configuration/materials/DepMaterialsConfiguration");

export const settingsRoutes = [
  {
    path: "/configuration/panel",
    component: SettingsTabs,
    children: [
      {
        path: "",
        name: "general-settings",
        component: DepGeneralConfiguration,
      },
      {
        path: "Kn-Chat",
        name: "kn-chat",
        component: DepKnChatConfiguration,
      },
      {
        path: "Kn-Explorer",
        name: "kn-explorer",
        component: DepKnExplorerConfiguration,
      },
      {
        path: "Materials",
        name: "Materials",
        component: DepMaterialsConfiguration,
      },
    ],
  },
];
